import React from "react";
import * as Modal from "../../../../../../common-deprecated/styles/v2/toyota/globals/Modal";
import Icon from "../../../../../../common-deprecated/styles/v2/toyota/globals/Icon";
import { IconWrapper } from "../../../../../../common-deprecated/styles/v2/toyota/globals/IconWrapper";
import { BnbLabel } from "../../../utils/labels";
import * as Styles from "./styles/MassManagementStyles";
import CarAccessoriesVisual from "../../../../../../common-deprecated/svg/toyota/car-accessories.svg";
import IconExclamation from "../../../../../../common-deprecated/svg/toyota/exclamation.svg";
import * as Button from "../../../../../../common-deprecated/styles/v2/toyota/components/Button";
import ModalBaseView from "../../../../../../common-deprecated/components/modals/aem/ModalBaseView";
import * as InputStyles from "../../../../../../common-deprecated/styles/toyota/Input";
import useModalMassManagement from "../../../hooks/shared/useModalMassManagement";
import type { MassManagementModalType } from "../../../utils/modalConstants";
import type { ModalViewType } from "../../../../../../common-deprecated/types/CommonTypes";
import { useCommonLabel } from "../../../../../../common-deprecated/utils/commonLabels";

type SelectableBaseItemType = { id: string; name: string };
const SelectableItem = <T extends SelectableBaseItemType>({
    item,
    selected,
    onClick,
}: {
    item: T;
    selected: boolean;
    onClick: (item: T, selected: boolean) => void;
}): JSX.Element => {
    return (
        <InputStyles.Wrapper>
            <input type="checkbox" id={`mm-${item.id}`} checked={selected} onChange={() => onClick(item, selected)} />
            <InputStyles.Checkbox htmlFor={`mm-${item.id}`}>{item.name}</InputStyles.Checkbox>
        </InputStyles.Wrapper>
    );
};

const MassManagementModal = (props: ModalViewType<MassManagementModalType>): JSX.Element => {
    const { show, close, modalSettings } = props;
    const { onCancel, onOk, validates, exceedingKilogram, originalBasket, packs, extras, packClick, extraClick } =
        useModalMassManagement(close);

    const closeLabel = useCommonLabel("close");

    return (
        <ModalBaseView modalIdType={modalSettings.type} onClose={onCancel} show={show} size="md">
            <Modal.Header>
                <Modal.Title>
                    <BnbLabel label="massManagementModalTitle" />
                </Modal.Title>
                <Modal.Button type="button" aria-label={closeLabel} onClick={onCancel}>
                    <IconWrapper>
                        <Icon variant="close" />
                    </IconWrapper>
                </Modal.Button>
            </Modal.Header>
            <Modal.Body>
                <Styles.Visual>
                    <CarAccessoriesVisual viewBox="0 0 346 130" />
                </Styles.Visual>
                {/* Summary */}
                <div>
                    <Styles.InfoText>
                        <BnbLabel label="massManagementModalDescription" params={{ value: exceedingKilogram }} />
                    </Styles.InfoText>
                </div>
                {/* Extras */}
                <div>
                    <Styles.ExtrasTitle>
                        <BnbLabel label="massManagementModalSelectedItemsTitle" />
                    </Styles.ExtrasTitle>
                    <Styles.InfoText>
                        {validates ? (
                            <BnbLabel label="massManagementModalSelectedItemsValidates" />
                        ) : (
                            <>
                                <Styles.IconWrapper>
                                    <IconExclamation />
                                </Styles.IconWrapper>
                                <BnbLabel
                                    label="massManagementModalSelectedItemsError"
                                    params={{ value: exceedingKilogram }}
                                />
                            </>
                        )}
                    </Styles.InfoText>
                    <Styles.ExtraListWrapper>
                        {originalBasket.packs.map((pack) => (
                            <SelectableItem
                                key={pack.id}
                                item={pack}
                                selected={!!packs.find((selectedPack) => selectedPack.id === pack.id)}
                                onClick={packClick}
                            />
                        ))}
                        {originalBasket.extras.map((extra) => (
                            <SelectableItem
                                key={extra.id}
                                item={extra}
                                selected={!!extras.find((selectedExtra) => selectedExtra.id === extra.id)}
                                onClick={extraClick}
                            />
                        ))}
                    </Styles.ExtraListWrapper>
                </div>
            </Modal.Body>
            <Modal.Actions>
                <Button.Primary onClick={onOk}>
                    <BnbLabel label="massManagementModalOk" />
                </Button.Primary>
                <Button.Secondary onClick={onCancel}>
                    <BnbLabel label="massManagementModalCancel" />
                </Button.Secondary>
            </Modal.Actions>
        </ModalBaseView>
    );
};

export default MassManagementModal;
